module.exports = __webpack_public_path__ + "media/Slide2.b6f65d51.mp3";